angular.module("ainapp")
    .controller("leaveAttSumReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Leave - Attendance Summary Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })


            $scope.Init = function () {

                $scope.filter = {
                    EmployeeId: "",
                    YearNo: new Date().getFullYear(),
                    MonthNo: new Date().getMonth() + 1,
                }

                $scope.load = false;
                $scope.EmployeeData = {};



            }
            $scope.Init();


            $scope.filterData = function () {

                if ($scope.filter.EmployeeId == "") {
                    toastr.warning("Choose Employee");
                } else if ($scope.filter.YearNo == "") {
                    toastr.warning("Choose Year");
                } else if ($scope.filter.MonthNo == "") {
                    toastr.warning("Choose Month");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetMonthlyAttLeaveSummary($scope.filter).then(function (response) {
                        if (response.data) {
                            $scope.EmployeeData = response.data;
                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }

            }

            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();



                MainService.PrintCPVMasterReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
